'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _angularFix = require('angular-fix');

var _angularFix2 = _interopRequireDefault(_angularFix);

var _otherUtils = require('../other/utils');

exports['default'] = addFormlyNgModelAttrsManipulator;

// @ngInject
function addFormlyNgModelAttrsManipulator(formlyConfig, $interpolate) {
  if (formlyConfig.extras.disableNgModelAttrsManipulator) {
    return;
  }
  formlyConfig.templateManipulators.preWrapper.push(ngModelAttrsManipulator);

  function ngModelAttrsManipulator(template, options, scope) {
    var node = document.createElement('div');
    var skip = options.extras && options.extras.skipNgModelAttrsManipulator;
    if (skip === true) {
      return template;
    }
    node.innerHTML = template;

    var modelNodes = getNgModelNodes(node, skip);
    if (!modelNodes || !modelNodes.length) {
      return template;
    }

    addIfNotPresent(modelNodes, 'id', scope.id);
    addIfNotPresent(modelNodes, 'name', scope.name || scope.id);

    addValidation();
    alterNgModelAttr();
    addModelOptions();
    addTemplateOptionsAttrs();
    addNgModelElAttrs();

    return node.innerHTML;

    function addValidation() {
      if (_angularFix2['default'].isDefined(options.validators) || _angularFix2['default'].isDefined(options.validation.messages)) {
        addIfNotPresent(modelNodes, 'formly-custom-validation', '');
      }
    }

    function alterNgModelAttr() {
      if (isPropertyAccessor(options.key)) {
        addRegardlessOfPresence(modelNodes, 'ng-model', 'model.' + options.key);
      }
    }

    function addModelOptions() {
      if (_angularFix2['default'].isDefined(options.modelOptions)) {
        addIfNotPresent(modelNodes, 'ng-model-options', 'options.modelOptions');
        if (options.modelOptions.getterSetter) {
          addRegardlessOfPresence(modelNodes, 'ng-model', 'options.value');
        }
      }
    }

    function addTemplateOptionsAttrs() {
      if (!options.templateOptions && !options.expressionProperties) {
        // no need to run these if there are no templateOptions or expressionProperties
        return;
      }
      var to = options.templateOptions || {};
      var ep = options.expressionProperties || {};

      var ngModelAttributes = getBuiltInAttributes();

      // extend with the user's specifications winning
      _angularFix2['default'].extend(ngModelAttributes, options.ngModelAttrs);

      // Feel free to make this more simple :-)
      _angularFix2['default'].forEach(ngModelAttributes, function (val, name) {
        /* eslint complexity:[2, 14] */
        var attrVal = undefined,
            attrName = undefined;
        var ref = 'options.templateOptions[\'' + name + '\']';
        var toVal = to[name];
        var epVal = getEpValue(ep, name);

        var inTo = _angularFix2['default'].isDefined(toVal);
        var inEp = _angularFix2['default'].isDefined(epVal);
        if (val.value) {
          // I realize this looks backwards, but it's right, trust me...
          attrName = val.value;
          attrVal = name;
        } else if (val.statement && inTo) {
          attrName = val.statement;
          if (_angularFix2['default'].isString(to[name])) {
            attrVal = '$eval(' + ref + ')';
          } else if (_angularFix2['default'].isFunction(to[name])) {
            attrVal = ref + '(model[options.key], options, this, $event)';
          } else {
            throw new Error('options.templateOptions.' + name + ' must be a string or function: ' + JSON.stringify(options));
          }
        } else if (val.bound && inEp) {
          attrName = val.bound;
          attrVal = ref;
        } else if ((val.attribute || val.boolean) && inEp) {
          attrName = val.attribute || val.boolean;
          attrVal = '' + $interpolate.startSymbol() + ref + $interpolate.endSymbol();
        } else if (val.attribute && inTo) {
          attrName = val.attribute;
          attrVal = toVal;
        } else if (val.boolean) {
          if (inTo && !inEp && toVal) {
            attrName = val.boolean;
            attrVal = true;
          } else {
            /* eslint no-empty:0 */
            // empty to illustrate that a boolean will not be added via val.bound
            // if you want it added via val.bound, then put it in expressionProperties
          }
        } else if (val.bound && inTo) {
            attrName = val.bound;
            attrVal = ref;
          }

        if (_angularFix2['default'].isDefined(attrName) && _angularFix2['default'].isDefined(attrVal)) {
          addIfNotPresent(modelNodes, attrName, attrVal);
        }
      });
    }

    function addNgModelElAttrs() {
      _angularFix2['default'].forEach(options.ngModelElAttrs, function (val, name) {
        addRegardlessOfPresence(modelNodes, name, val);
      });
    }
  }

  // Utility functions
  function getNgModelNodes(node, skip) {
    var selectorNot = _angularFix2['default'].isString(skip) ? ':not(' + skip + ')' : '';
    var skipNot = ':not([formly-skip-ng-model-attrs-manipulator])';
    var query = '[ng-model]' + selectorNot + skipNot + ', [data-ng-model]' + selectorNot + skipNot;
    try {
      return node.querySelectorAll(query);
    } catch (e) {
      //this code is needed for IE8, as it does not support the CSS3 ':not' selector
      //it should be removed when IE8 support is dropped
      return getNgModelNodesFallback(node, skip);
    }
  }

  function getNgModelNodesFallback(node, skip) {
    var allNgModelNodes = node.querySelectorAll('[ng-model], [data-ng-model]');
    var matchingNgModelNodes = [];

    //make sure this array is compatible with NodeList type by adding an 'item' function
    matchingNgModelNodes.item = function (i) {
      return this[i];
    };

    for (var i = 0; i < allNgModelNodes.length; i++) {
      var ngModelNode = allNgModelNodes[i];
      if (!ngModelNode.hasAttribute('formly-skip-ng-model-attrs-manipulator') && !(_angularFix2['default'].isString(skip) && nodeMatches(ngModelNode, skip))) {
        matchingNgModelNodes.push(ngModelNode);
      }
    }

    return matchingNgModelNodes;
  }

  function nodeMatches(node, selector) {
    var div = document.createElement('div');
    div.innerHTML = node.outerHTML;
    return div.querySelector(selector);
  }

  function getBuiltInAttributes() {
    var ngModelAttributes = {
      focus: {
        attribute: 'formly-focus'
      }
    };
    var boundOnly = [];
    var bothBooleanAndBound = ['required', 'disabled'];
    var bothAttributeAndBound = ['pattern', 'minlength'];
    var statementOnly = ['change', 'keydown', 'keyup', 'keypress', 'click', 'focus', 'blur'];
    var attributeOnly = ['placeholder', 'min', 'max', 'step', 'tabindex', 'type'];
    if (formlyConfig.extras.ngModelAttrsManipulatorPreferUnbound) {
      bothAttributeAndBound.push('maxlength');
    } else {
      boundOnly.push('maxlength');
    }

    _angularFix2['default'].forEach(boundOnly, function (item) {
      ngModelAttributes[item] = { bound: 'ng-' + item };
    });

    _angularFix2['default'].forEach(bothBooleanAndBound, function (item) {
      ngModelAttributes[item] = { boolean: item, bound: 'ng-' + item };
    });

    _angularFix2['default'].forEach(bothAttributeAndBound, function (item) {
      ngModelAttributes[item] = { attribute: item, bound: 'ng-' + item };
    });

    _angularFix2['default'].forEach(statementOnly, function (item) {
      var propName = 'on' + item.substr(0, 1).toUpperCase() + item.substr(1);
      ngModelAttributes[propName] = { statement: 'ng-' + item };
    });

    _angularFix2['default'].forEach(attributeOnly, function (item) {
      ngModelAttributes[item] = { attribute: item };
    });
    return ngModelAttributes;
  }

  function getEpValue(ep, name) {
    return ep['templateOptions.' + name] || ep['templateOptions[\'' + name + '\']'] || ep['templateOptions["' + name + '"]'];
  }

  function addIfNotPresent(nodes, attr, val) {
    _angularFix2['default'].forEach(nodes, function (node) {
      if (!node.getAttribute(attr)) {
        node.setAttribute(attr, val);
      }
    });
  }

  function addRegardlessOfPresence(nodes, attr, val) {
    _angularFix2['default'].forEach(nodes, function (node) {
      node.setAttribute(attr, val);
    });
  }

  function isPropertyAccessor(key) {
    return (0, _otherUtils.contains)(key, '.') || (0, _otherUtils.contains)(key, '[') && (0, _otherUtils.contains)(key, ']');
  }
}
module.exports = exports['default'];


/** WEBPACK FOOTER **
 ** ./run/formlyNgModelAttrsManipulator.js
 **/